import { useTranslation } from 'react-i18next';

const ensureObject = (value) => (value && typeof value === 'object' ? value : {});

export function usePageMeta(key) {
  const { t } = useTranslation();
  const defaults = ensureObject(t('meta.default', { returnObjects: true }));
  const page = key ? ensureObject(t(`meta.${key}`, { returnObjects: true })) : {};

  return {
    ...defaults,
    ...page,
  };
}
